import { toBig, type Security } from '@talos/kyoko';

/**
 * Default order quantity for a prediction card. A non-blank configured quantity is returned
 * trimmed and takes precedence. Otherwise this is the largest NormalSize among the given
 * securities, or undefined when neither source yields a value.
 */
export function getPredictionCardQuantity(
  configuredQuantity: string | undefined,
  securities: readonly Security[]
): string | undefined {
  const trimmedQuantity = configuredQuantity?.trim();
  if (trimmedQuantity) {
    return trimmedQuantity;
  }

  let largestNormalSize: string | undefined;
  let largestNormalSizeValue = toBig(undefined);

  for (const security of securities) {
    const normalSizeValue = toBig(security.NormalSize);
    if (normalSizeValue == null || (largestNormalSizeValue != null && !normalSizeValue.gt(largestNormalSizeValue))) {
      continue;
    }

    largestNormalSize = security.NormalSize;
    largestNormalSizeValue = normalSizeValue;
  }

  return largestNormalSize;
}
